/** KIT-UC-1.CC-2: языки справочника и скила; без параметра или с другим языком — английский. */
export enum ToolkitLocale {
  En = 'en',
  Ru = 'ru',
}

export function toolkitLocale(lang: unknown): ToolkitLocale {
  return lang === ToolkitLocale.Ru ? ToolkitLocale.Ru : ToolkitLocale.En;
}
